import React, { useState } from 'react';
import { 
  FiSearch, 
  FiFilter, 
  FiEye, 
  FiCheckCircle, 
  FiAlertTriangle, 
  FiMessageSquare,
  FiX,
  FiSend,
  FiActivity
} from 'react-icons/fi';

const Complaints = () => {
  const [filterDate, setFilterDate] = useState('');
  const [filterGP, setFilterGP] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(null);
  const [actionNote, setActionNote] = useState('');

  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    bg: '#f8fafc',
    text: '#333333'
  };

  // Mock Data
  const complaints = [
    {
      id: 'CMP-2026-001',
      citizen: 'विमल पाटील',
      gpName: 'इनाम धामणी',
      subject: 'पाणीपुरवठा अनियमितता',
      date: '१५/०२/२०२६',
      status: 'उघडी', // Open
      description: 'गेल्या ४ दिवसांपासून आमच्या वार्ड क्रमांक ३ मध्ये पाणीपुरवठा वेळेवर होत नाही. कृपया लवकरात लवकर दखल घ्यावी.',
      mobile: '९८७६५४३२१०',
      photoUrl: 'placeholder' 
    },
    {
      id: 'CMP-2026-002',
      citizen: 'राजेश शहा',
      gpName: 'बेडग',
      subject: 'रस्त्यावरील दिवे बंद',
      date: '१४/०२/२०२६',
      status: 'प्रक्रियेत', // In Progress
      description: 'मेन चौकातील ३ स्ट्रीट लाइट्स गेल्या आठवड्यापासून बंद आहेत. रात्रीच्या वेळी खूप अंधार असतो.',
      mobile: '९८७६५१२३४५',
      photoUrl: 'placeholder'
    },
    {
      id: 'CMP-2026-003',
      citizen: 'सुनीता देसाई',
      gpName: 'आरग',
      subject: 'कचरा उचलण्यात विलंब',
      date: '१०/०२/२०२६',
      status: 'पूर्ण', // Closed
      description: 'घंटागाडी वेळेवर येत नाही. कचरा साचला आहे.',
      mobile: '९१२३४५६७८९',
      photoUrl: 'placeholder'
    },
    {
      id: 'CMP-2026-004',
      citizen: 'अमित कुमार',
      gpName: 'इनाम धामणी',
      subject: 'गटार तुंबले आहे',
      date: '१८/०२/२०२६',
      status: 'उघडी',
      description: 'पावसामुळे गटार तुंबले असून दुर्गंधी पसरली आहे.',
      mobile: '८८८८७७७७६६',
      photoUrl: 'placeholder'
    }
  ];

  const getStatusBadge = (status) => {
    switch(status) {
      case 'पूर्ण': return <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold font-mono">पूर्ण (Resolved)</span>;
      case 'प्रक्रियेत': return <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-bold font-mono">प्रक्रियेत (In Progress)</span>;
      default: return <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-bold font-mono">उघडी (Open)</span>;
    }
  };

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>तक्रार व अभिप्राय</h1>
        <p className="text-gray-600 text-sm">नागरिकांच्या तक्रारींचे निवारण आणि व्यवस्थापन.</p>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white p-4 rounded-xl shadow-sm border border-l-4 border-blue-500">
          <div className="text-gray-500 text-sm mb-1">एकूण तक्रारी</div>
          <div className="text-2xl font-bold text-gray-800">१२५</div>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-l-4 border-red-500">
          <div className="text-gray-500 text-sm mb-1">उघडी (Open)</div>
          <div className="text-2xl font-bold text-gray-800">१५</div>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-l-4 border-yellow-500">
          <div className="text-gray-500 text-sm mb-1">प्रक्रियेत (In Progress)</div>
          <div className="text-2xl font-bold text-gray-800">४५</div>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-l-4 border-green-500">
          <div className="text-gray-500 text-sm mb-1">पूर्ण (Resolved)</div>
          <div className="text-2xl font-bold text-gray-800">६५</div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex flex-col lg:flex-row gap-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 flex-1">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">दिनांक निवडा</label>
            <input 
              type="date" 
              className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
              onChange={(e) => setFilterDate(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">ग्रामपंचायत निवडा</label>
            <select 
              className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
              onChange={(e) => setFilterGP(e.target.value)}
            >
              <option value="">सर्व</option>
              <option value="ambegaon">आंबेगाव</option>
              <option value="malegaon">माळेगाव</option>
              <option value="shirpur">शिरपूर</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">तक्रार स्थिती</label>
            <select 
              className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">सर्व स्थिती</option>
              <option value="open">उघडी</option>
              <option value="inprogress">प्रक्रियेत</option>
              <option value="resolved">पूर्ण</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">शोध (नाव / विषय)</label>
            <div className="relative">
              <FiSearch className="absolute left-3 top-2.5 text-gray-400" size={14} />
              <input 
                type="text" 
                placeholder="शोधा..." 
                className="w-full pl-9 p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
        <button 
          className="px-6 py-2 text-white font-medium rounded-lg shadow-sm hover:opacity-90 transition-opacity self-end"
          style={{ backgroundColor: colors.primary }}
        >
          <FiFilter className="inline mr-2" /> फिल्टर लागू करा
        </button>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 text-gray-700 text-sm">
              <th className="p-4 font-semibold border-b">तक्रार क्र.</th>
              <th className="p-4 font-semibold border-b">नागरिक नाव</th>
              <th className="p-4 font-semibold border-b">ग्रामपंचायत</th>
              <th className="p-4 font-semibold border-b">तक्रार विषय</th>
              <th className="p-4 font-semibold border-b">दिनांक</th>
              <th className="p-4 font-semibold border-b">स्थिती</th>
              <th className="p-4 font-semibold border-b text-center">कृती</th>
            </tr>
          </thead>
          <tbody className="text-sm divide-y divide-gray-100">
            {complaints.map((comp) => (
              <tr key={comp.id} className="hover:bg-gray-50">
                <td className="p-4 font-mono font-medium text-blue-600">{comp.id}</td>
                <td className="p-4 font-medium text-gray-800">
                  {comp.citizen}
                  <div className="text-xs text-gray-500 mt-0.5">{comp.mobile}</div>
                </td>
                <td className="p-4 text-gray-600">{comp.gpName}</td>
                <td className="p-4 text-gray-600 font-medium">{comp.subject}</td>
                <td className="p-4 text-gray-600 font-mono">{comp.date}</td>
                <td className="p-4">{getStatusBadge(comp.status)}</td>
                <td className="p-4 text-center">
                  <div className="flex justify-center gap-2">
                    <button 
                      onClick={() => setShowModal(comp)}
                      className="p-2 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 transition-colors"
                      title="तपशील पाहा"
                    >
                      <FiEye size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Detail Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col max-h-[90vh]">
            <div className="p-5 border-b flex justify-between items-center" style={{ backgroundColor: colors.primary }}>
              <h2 className="text-lg font-bold text-white flex items-center">
                <FiMessageSquare className="mr-2" /> तक्रार तपशील: {showModal.id}
              </h2>
              <button 
                onClick={() => setShowModal(null)} 
                className="text-white hover:bg-white/20 p-2 rounded-full transition-colors"
              >
                <FiX size={20} />
              </button>
            </div>
            
            <div className="flex-1 overflow-auto p-6">
              <div className="space-y-6">
                 {/* ID and Status */}
                 <div className="flex justify-between items-start">
                   <div>
                     <span className="block text-xs text-gray-500 uppercase tracking-wide">तक्रार विषय</span>
                     <span className="text-xl font-bold text-gray-800">{showModal.subject}</span>
                   </div>
                   <div>
                      {getStatusBadge(showModal.status)}
                   </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-gray-50 p-4 rounded-xl border border-gray-100">
                    <div>
                      <span className="block text-xs text-gray-500 mb-1">नागरिक:</span>
                      <span className="font-medium text-gray-800">{showModal.citizen}</span>
                    </div>
                    <div>
                      <span className="block text-xs text-gray-500 mb-1">संपर्क क्रमांक:</span>
                      <span className="font-medium text-gray-800 font-mono">{showModal.mobile}</span>
                    </div>
                    <div>
                      <span className="block text-xs text-gray-500 mb-1">ग्रामपंचायत:</span>
                      <span className="font-medium text-gray-800">{showModal.gpName}</span>
                    </div>
                    <div>
                      <span className="block text-xs text-gray-500 mb-1">तक्रार दिनांक:</span>
                      <span className="font-medium text-gray-800 font-mono">{showModal.date}</span>
                    </div>
                 </div>

                 <div>
                   <h3 className="text-sm font-bold text-gray-700 mb-2 border-b pb-1">तक्रार वर्णन</h3>
                   <p className="text-gray-600 bg-white p-3 rounded-lg border border-gray-200 leading-relaxed">
                     {showModal.description}
                   </p>
                 </div>

                 {/* Photo/Doc Placeholder */}
                 <div>
                   <h3 className="text-sm font-bold text-gray-700 mb-2 border-b pb-1">जोडलेले फोटो / दस्तऐवज</h3>
                   <div className="flex gap-4 overflow-x-auto py-2">
                     <div className="w-24 h-24 bg-gray-200 rounded-lg flex items-center justify-center text-gray-400 border border-gray-300">
                        <span className="text-xs">फोटो १</span>
                     </div>
                     <div className="w-24 h-24 bg-gray-200 rounded-lg flex items-center justify-center text-gray-400 border border-gray-300">
                        <span className="text-xs">फोटो २</span>
                     </div>
                   </div>
                 </div>

                 {/* Action Section */}
                 <div className="bg-blue-50 p-4 rounded-xl border border-blue-100">
                    <h3 className="text-sm font-bold text-blue-800 mb-2">निवारण नोंद करा (Resolution Note)</h3>
                    <textarea 
                      className="w-full p-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white text-sm"
                      rows="3"
                      placeholder="येथे निवारण नोंद लिहा..."
                      value={actionNote}
                      onChange={(e) => setActionNote(e.target.value)}
                    ></textarea>
                 </div>
              </div>
            </div>

            <div className="p-4 border-t bg-gray-50 flex justify-end gap-3">
              <button 
                className="px-4 py-2 text-orange-600 bg-white border border-orange-200 rounded-lg font-medium hover:bg-orange-50 transition-colors flex items-center"
              >
                <FiSend className="mr-2" /> उच्चस्तरीय पाठवा (Escalate)
              </button>
              <button 
                className="px-6 py-2 text-white rounded-lg font-medium shadow-sm transition-colors flex items-center"
                style={{ backgroundColor: colors.primary }}
                onClick={() => {
                  alert("तक्रार निवारण नोंदवण्यात आले आहे.");
                  setShowModal(null);
                }}
              >
                <FiCheckCircle className="mr-2" /> निवारण नोंद करा (Resolve)
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Complaints;
